export default function importLeads(params) {
    // Otevre popup, kterej vsechno resi
    this.popup('ImportLeads', params);
}